import { Component } from '@angular/core';
import { GridShapeComponent } from '../../components/common/grid-shape/grid-shape.component';
import { RouterModule } from '@angular/router';
import { ThemeToggleTwoComponent } from '../../components/common/theme-toggle-two/theme-toggle-two.component';
import { LanguageSwitchComponent } from '../../components/common/language-switch/language-switch.component';
import { TPipe } from '../../pipe/t.pipe';

@Component({
  selector: 'app-auth-page-layout',
  imports: [GridShapeComponent, RouterModule, ThemeToggleTwoComponent, LanguageSwitchComponent, TPipe],
  templateUrl: './auth-page-layout.component.html',
  styles: ``
})
export class AuthPageLayoutComponent {

}
